import { render, staticRenderFns } from "./ModelPrices.vue?vue&type=template&id=f48aca06&scoped=true"
import script from "./ModelPrices.vue?vue&type=script&lang=js"
export * from "./ModelPrices.vue?vue&type=script&lang=js"
import style0 from "./ModelPrices.vue?vue&type=style&index=0&id=f48aca06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48aca06",
  null
  
)

export default component.exports